import { SECTION_TITLE_ALIGN, SECTION_TITLE_FONT_SIZE } from './sectionSettings.constants';

const ALIGNMENTS = Object.values(SECTION_TITLE_ALIGN);

/**
 * Inline style for a section title from `section.settings.titleStyle`. Only the
 * options the author changed are returned, so anything unset keeps the
 * `.form-builder-section-title` defaults (16px, #172b4d, semi-bold).
 */
export const sectionTitleStyle = (section) => {
    const titleStyle = section?.settings?.titleStyle || {};
    const fontSize = Number(titleStyle.fontSize)
        ? Math.min(SECTION_TITLE_FONT_SIZE.max, Math.max(SECTION_TITLE_FONT_SIZE.min, Number(titleStyle.fontSize)))
        : null;
    return {
        ...(fontSize ? { fontSize: `${fontSize}px` } : {}),
        ...(titleStyle.color ? { color: titleStyle.color } : {}),
        ...(titleStyle.bold !== undefined ? { fontWeight: titleStyle.bold ? 600 : 400 } : {}),
        ...(titleStyle.italic ? { fontStyle: 'italic' } : {}),
        ...(titleStyle.underline ? { textDecoration: 'underline' } : {}),
        ...(ALIGNMENTS.includes(titleStyle.align) ? { textAlign: titleStyle.align } : {}),
    };
};

/** Same rule as the PDF (`sectionTitleFields`): a named section whose title is not hidden. */
export const showSectionTitle = (section) => !!section?.name?.trim() && !section?.settings?.hideTitle;
